import { Trans, useLingui } from '@lingui/react/macro';
import { Expand } from 'lucide-react';
import { useRef } from 'react';
import { SimulationMeshViewer } from '@/components/SimulationMeshViewer';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const SimulationMeshCard = ({ projectId }: { projectId: string }): React.ReactElement => {
  const { t } = useLingui();
  const viewerRef = useRef<HTMLDivElement>(null);

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Trans>3D simulation view</Trans>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div ref={viewerRef} className="h-[500px] w-full bg-white">
          <SimulationMeshViewer projectId={projectId} className="h-full w-full" />
        </div>
        <div className="flex items-center justify-between gap-4 pt-2 text-sm text-slate-500">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1.5">
              <span className="inline-block h-3 w-3 border border-solid border-slate-500 bg-[#ffff00]" />
              <Trans>Unremoved material</Trans>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="inline-block h-3 w-3 border border-solid border-slate-500 bg-[#ff0000]" />
              <Trans>Collisions</Trans>
            </div>
          </div>
          <Button
            type="button"
            size="icon"
            variant="ghost"
            onClick={() => viewerRef.current?.requestFullscreen()}
            title={t`Enter fullscreen`}
          >
            <Expand />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
